import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import classes from './ScheduledAppointment.module.css';
import { locale } from 'devextreme/localization';


const scheduledAppointment = (props) => {
    locale(navigator.language);
    const dateFormatter = new Intl.DateTimeFormat(navigator.language, {
        timeStyle: 'short'
    });
    const appointmentData = props.appointmentData;

    let cellStyle = {
        height:          '100%',
        borderRadius:    '5px',
        border:          '1px solid gray',
        borderLeft:      'solid 8px',
        padding:         '5px',
        backgroundColor: 'white',
        color:           'black',
        zIndex:          '25'
    };

    cellStyle.borderLeftColor = props.statusColor;
    let apptDate = new Date(appointmentData.startdatetime);
    let endDate = new Date(appointmentData.enddatetime);

    const toolTipList = [];
    let type = appointmentData.type === 'ServiceCall' ? 'Service Call' : appointmentData.type === 'Job' ? 'Job' : 'Technician Activity';
    let line = <div key={1} style={{padding: '5px'}}>{dateFormatter.format(new Date(apptDate)) + ' - ' + dateFormatter.format(new Date(endDate)) + ' (Estimated ' + +appointmentData.estimateHours + ' Hrs)'}</div>;
    toolTipList.push(line);
    toolTipList.push(<div key={2} style={{padding: '5px'}}>{'Event - ' + type}</div>);
    toolTipList.push(<div key={3} style={{padding: '5px'}}>{'Status - ' + appointmentData.status}</div>);

    
    return (
        <div style={cellStyle}>
            <Tooltip
                title={
                    <span className={classes.Tooltip}>
                        {toolTipList}
                    </span>
                }
                placement="top-start"
            >
                <div style={{ height: '100%' }}>
                    <div style={{ fontWeight: 'bold' }}>{'Tech Activity'}</div>
                    <div>{dateFormatter.format(new Date(apptDate)) + ' - ' + dateFormatter.format(new Date(endDate))}</div>
                </div>
            </Tooltip>
        </div>
    );
};
export default scheduledAppointment;
